"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebPipelineProxy = void 0;
const guard_1 = require("../utils/guard");
const axios_1 = require("axios");
const utils_1 = require("../logging/utils");
const utils_2 = require("../resilience/utils");
const timer_1 = require("../utils/timer");
const guid_typescript_1 = require("guid-typescript");
/**
 * A web pipeline proxy.
 */
class WebPipelineProxy {
    /**
     * Initializes a new instance of the @see WebPipelineProxy class.
     * @param pipeline The pipeline to use if any.
     * @param itemCache The item cache to use if any.
     * @param tokenCache The token cache to use if any.
     * @param baseUrl The base URL to use if any.
     * @param logger Logger to use if any.
     * @param maintenance Maintenance for pipepline.
     */
    constructor(pipeline = null, itemCache = null, tokenCache = null, baseUrl = null, logger = null, maintenance = null) {
        this.pipeline = pipeline;
        this.tokenCache = tokenCache;
        this.itemCache = itemCache;
        this.baseUrl = baseUrl;
        this.logger = logger;
        this.maint = maintenance;
    }
    /**
     * Sends a web request through the pipeline.
     * @param request Request to send.
     * @param cacheKey Optional cache key.
     * @param requestId Request Guid.
     * @returns Web response.
     */
    execute(request, cacheKey, requestId) {
        return __awaiter(this, void 0, void 0, function* () {
            guard_1.Guard.throwIfNullOrEmpty(request, 'request');
            if (this.itemCache) {
                guard_1.Guard.throwIfNullOrEmpty(cacheKey, 'cacheKey');
            }
            if (this.baseUrl) {
                request.baseURL = this.baseUrl;
            }
            if (!requestId) {
                requestId = guid_typescript_1.Guid.create();
            }
            if (this.tokenCache) {
                const token = yield this.tokenCache.getToken(requestId);
                if (request.headers) {
                    request.headers.Authorization = `Bearer ${token.accessToken}`;
                }
                else {
                    request.headers = {
                        Authorization: `Bearer ${token.accessToken}`,
                    };
                }
            }
            let result;
            if (this.logger) {
                this.logger.information(requestId, `start ${request.method.toUpperCase()} '${utils_1.getUrlFromAxisRequest(request)}'`, null, utils_2.logFormatter);
            }
            const durationTimer = timer_1.timer();
            if (this.itemCache && cacheKey && this.pipeline) {
                result = yield this.itemCache.execute(() => this.pipeline.execute(() => axios_1.default(request), requestId), cacheKey);
            }
            else {
                if (this.itemCache && cacheKey && !this.pipeline) {
                    result = yield this.itemCache.execute(() => axios_1.default(request), cacheKey);
                }
                else {
                    if (this.pipeline) {
                        result = yield this.pipeline.execute(() => axios_1.default(request), requestId);
                    }
                    else {
                        result = yield axios_1.default(request);
                    }
                }
            }
            const milliseconds = durationTimer.milliSeconds;
            if (this.logger) {
                this.logger.information(requestId, `end ${result.status} in ${milliseconds}ms`, null, utils_2.logFormatter);
            }
            return result;
        });
    }
    /**
     * Gets the maintenance.
     * @returns Maintenance for the pipeline.
     */
    maintenance() {
        guard_1.Guard.throwIfNullOrEmpty(this.maint, 'this.maint');
        return this.maint;
    }
}
exports.WebPipelineProxy = WebPipelineProxy;
//# sourceMappingURL=webPipelineProxy.js.map